var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDots = function SvgDots(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 96,
    viewBox: "0 0 95 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 45,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 65,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 65,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 5,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 85,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 5,
    cy: 25,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 5,
    cy: 45,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 85,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 25,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 45,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 65,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 22,
    cy: 5,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 65,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 5,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 85,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 25,
    r: 5,
    fill: "#FFC044",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 22,
    cy: 45,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 85,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 25,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 45,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 65,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 5,
    r: 5,
    fill: "#FFC044",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 65,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 5,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 85,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 25,
    r: 5,
    fill: "#FFC044",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 45,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 85,
    r: 5,
    fill: "#FFC044"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 25,
    r: 5,
    fill: "#FFC044"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDots);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dots.84d0e93c913e576b09bb62f813a9dd81.svg";